module.exports = [{
  plugin: require('/vercel/598dfd29/node_modules/@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/vercel/598dfd29/deck.mdx",
    "dirname": "/vercel/598dfd29"
  }
}];